import { type ReactNode } from "react"

type Props = {
  className?: string
  children: ReactNode
}

const InformationGrid = ({ className, children }: Props) => {
  return (
    <dl className={`grid grid-cols-[auto_1fr] items-center gap-2 text-sm ${className}`}>
      {children}
    </dl>
  )
}

export default InformationGrid
